import UpdateAdministrator from "../../../components/@users/administrators/UpdateAdministrator";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProfilePage() {

    return (
        <UpdateAdministrator 
            routeType={routeTypes.admin}
        />
    )
}       